import React from 'react';
import { Page, PageHeader, PageBody } from "../base/Page";
import { browserHistory } from "react-router";
import { Button, Row, Col, Panel, FormGroup, FormControl, ControlLabel } from 'react-bootstrap';
import API from "../base/API";
import Auth from "../auth/Auth";
import { translate } from '../base/Translation';

export default class BrandEdit extends Auth {

	constructor(props) {
		super(props);

		this.api = new API({
			save_brand: "/brand/save/:brand",
			get_brand: "/brand/fetch/:brand"
		});

		this.state = {
			brand: null
		};
	}

	fetchData() {
		this.api.request({
			route: "get_brand",
			params: { brand: this.props.params.brandID },
			success: (response) => {
				this.setState({ brand: response });
			}
		});
	}

	saveData() {
		this.api.request({
			route: "save_brand",
			params: { brand: this.props.params.brandID },
			data: this.state.brand,
			created: (response) => {
				browserHistory.push("/brands");
			}
		});
	}

	componentDidMount() {
		this.fetchData();
	}

	onBrandChange(evt) {
		// Get data from state
		let newBrand = this.state.brand;

		// Update it's value
		newBrand[evt.target.name] = evt.target.value;

		// Update data in state
		this.setState({ brand: newBrand });
	}

	onBrandSave(evt) {
		this.saveData();
	}

	render() {

		if (this.state.brand === null) {
			return (
				<Page>
					<PageHeader>{translate("Prosím počkajte")}</PageHeader>
					<PageBody>{translate("Obsah sa načítava")}</PageBody>
				</Page>
			);
		}

		return (
			<Page>
				<PageHeader title={this.state.brand.name} />
				<PageBody>
					<Row>
						<Col lg={6}>
							<Panel header={translate("Základné")}>
								<FormGroup>
									<ControlLabel>{translate("Názov")}</ControlLabel>
									<FormControl defaultValue={this.state.brand.name} name="name" onChange={this.onBrandChange.bind(this)} />
								</FormGroup>
							</Panel>
						</Col>
					</Row>
					<Row>
						<Col lg={12}>
							<FormGroup>
								<Button bsStyle="success" onClick={this.onBrandSave.bind(this)}>{translate("Uložiť")}</Button>
							</FormGroup>
						</Col>
					</Row>
				</PageBody>
			</Page>
		);
	}
}


// WEBPACK FOOTER //
// ./src/modules/brand/BrandEdit.js